var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTableBackIcon = function SvgTableBackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M18.756 5.327a3.25 3.25 0 0 1 2.488 0l8.252 3.418a3.25 3.25 0 0 1 1.759 1.759l3.418 8.252a3.25 3.25 0 0 1 0 2.488l-3.418 8.252a3.25 3.25 0 0 1-1.759 1.759l-8.252 3.418a3.25 3.25 0 0 1-2.488 0l-8.252-3.418a3.25 3.25 0 0 1-1.759-1.759l-3.418-8.252a3.25 3.25 0 0 1 0-2.488l3.418-8.252a3.25 3.25 0 0 1 1.759-1.759z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m22 14-6 6 6 6"
  })));
};
export default SvgTableBackIcon;